import React from 'react'
import { createRoot } from 'react-dom/client'
import { LKIcon } from 'loankeeper-common/components'

export function createIcon(alias: string): HTMLSpanElement {
  const node = document.createElement('span')
  const root = createRoot(node)
  root.render(<LKIcon alias={alias} style={{ height: 22 }} />)
  return node
}
